// Golf Club Care Kit - Product Page JavaScript

document.addEventListener('DOMContentLoaded', function() {
  const mediaGallery = document.querySelector('media-gallery');
  const paginationDotsContainer = document.querySelector('.slider-pagination-dots');

  if (!mediaGallery) {
    return;
  }

  const galleryViewer = mediaGallery.querySelector('[id^="GalleryViewer"]');
  const mediaItems = mediaGallery.querySelectorAll('.product__media-item');
  const dots = paginationDotsContainer ? paginationDotsContainer.querySelectorAll('.pagination-dot') : [];
  const prevButton = galleryViewer ? galleryViewer.querySelector('.slider-button--prev') : null;
  const nextButton = galleryViewer ? galleryViewer.querySelector('.slider-button--next') : null;

  if (mediaItems.length === 0) {
    return;
  }

  let currentIndex = 0;
  const slider = galleryViewer ? galleryViewer.querySelector('[id^="Slider-"]') : null;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function updateDots(index) {
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('active', isActive);
      dot.setAttribute('aria-current', String(isActive));
    });
  }

  // Find the initially active item
  mediaItems.forEach((item, index) => {
    if (item.classList.contains('is-active')) {
      currentIndex = index;
    }
  });

  // Listen to scroll events on the slider to update dots on swipe
  if (slider) {
    let scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        const scrollLeft = slider.scrollLeft;
        const itemWidth = mediaItems[0].offsetWidth;
        const newIndex = Math.round(scrollLeft / itemWidth);

        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < mediaItems.length) {
          currentIndex = newIndex;

          // Update dots
          updateDots(currentIndex);

          // Update is-active class
          mediaItems.forEach(item => item.classList.remove('is-active'));
          mediaItems[currentIndex].classList.add('is-active');
        }
      }, 50);
    });
  }

  // Function to switch to a specific slide
  function goToSlide(index) {
    if (index < 0 || index >= mediaItems.length) {
      return;
    }

    // Remove is-active from all items
    mediaItems.forEach(item => item.classList.remove('is-active'));

    // Add is-active to target item
    mediaItems[index].classList.add('is-active');

    // Update dots
    updateDots(index);

    currentIndex = index;

    // Scroll the slider to the target slide
    if (slider && mediaItems[index]) {
      const targetPosition = mediaItems[index].offsetLeft;
      slider.scrollTo({
        left: targetPosition,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    // Dispatch slideChanged event for media-gallery to handle
    const event = new CustomEvent('slideChanged', {
      detail: {
        currentElement: mediaItems[index]
      }
    });
    galleryViewer.dispatchEvent(event);
  }

  // Previous button click
  if (prevButton) {
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex > 0 ? currentIndex - 1 : mediaItems.length - 1;
      goToSlide(newIndex);
    });
  }

  // Next button click
  if (nextButton) {
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : 0;
      goToSlide(newIndex);
    });
  }

  // Pagination dot clicks
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      goToSlide(index);
    });
  });

  // Initialize first dot as active
  if (dots[currentIndex]) {
    updateDots(currentIndex);
  }
});

// Product-page interactions are delegated so they survive Shopify section
// re-renders and work equally well with touch, keyboard, and mouse input.
(function () {
  const SELECTOR = {
    carousel: '.cd-how-it-works__steps, .cd-review-showcase__cards',
    card: '.cd-how-step, .cd-review-card'
  };

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function updateCarouselControls(carousel) {
    const controls = carousel.parentElement.querySelector('[data-cd-carousel-controls]');
    if (!controls) return;
    const cards = Array.from(carousel.querySelectorAll(SELECTOR.card));
    if (!cards.length) return;
    const index = Math.max(0, Math.min(cards.length - 1, Math.round(carousel.scrollLeft / carousel.clientWidth)));
    controls.querySelector('[data-cd-carousel-current]').textContent = String(index + 1);
  }

  function addCarouselControls(carousel) {
    if (carousel.dataset.controlsReady === 'true') return;
    const cards = Array.from(carousel.querySelectorAll(SELECTOR.card));
    if (cards.length < 2) return;
    const controls = document.createElement('div');
    controls.className = 'cd-mobile-carousel-controls';
    controls.dataset.cdCarouselControls = '';
    controls.setAttribute('aria-label', carousel.matches('.cd-how-it-works__steps') ? 'Choose a care step' : 'Choose a customer review');
    controls.innerHTML = '<button type="button" data-cd-carousel-previous aria-label="Previous item"><span aria-hidden="true">←</span></button><span class="cd-mobile-carousel-controls__status" aria-live="polite"><strong data-cd-carousel-current>1</strong><span aria-hidden="true"> / </span><span data-cd-carousel-total>' + cards.length + '</span></span><button type="button" data-cd-carousel-next aria-label="Next item"><span aria-hidden="true">→</span></button>';
    carousel.insertAdjacentElement('afterend', controls);
    let scrollTimer;
    carousel.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => updateCarouselControls(carousel), 40);
    }, { passive: true });
    carousel.dataset.controlsReady = 'true';
    updateCarouselControls(carousel);
  }

  function initialize(root) {
    const proof = document.querySelector('.cd-result-proof');
    const miniKit = document.querySelector('[data-kit-mini]');
    if (proof && miniKit && miniKit.nextElementSibling !== proof) miniKit.insertAdjacentElement('afterend', proof);

    if (miniKit) {
      const selectedMiniItem = miniKit.querySelector('[data-kit-mini-item][aria-expanded="true"]') || miniKit.querySelector('[data-kit-mini-item]');
      const miniDetail = miniKit.querySelector('.cd-kit-mini__detail');
      if (selectedMiniItem && miniDetail) {
        miniKit.querySelectorAll('[data-kit-mini-item]').forEach((button) => {
          button.setAttribute('aria-expanded', String(button === selectedMiniItem));
        });
        miniDetail.hidden = false;
        miniDetail.querySelector('[data-kit-mini-detail-title]').textContent = selectedMiniItem.dataset.title;
        miniDetail.querySelector('[data-kit-mini-detail-copy]').textContent = selectedMiniItem.dataset.description;
      }
    }

    root.querySelectorAll('[data-kit-item]').forEach((item) => {
      item.setAttribute('role', 'button');
      if (!item.hasAttribute('aria-pressed')) item.setAttribute('aria-pressed', 'false');
    });
    root.querySelectorAll(SELECTOR.carousel).forEach(addCarouselControls);
  }

  document.addEventListener('click', (event) => {
    const miniButton = event.target.closest('[data-kit-mini-item]');
    if (miniButton) {
      const kit = miniButton.closest('[data-kit-mini]');
      const detail = kit?.querySelector('.cd-kit-mini__detail');
      if (!kit || !detail) return;
      kit.querySelectorAll('[data-kit-mini-item]').forEach((button) => {
        button.setAttribute('aria-expanded', String(button === miniButton));
      });
      detail.hidden = false;
      detail.querySelector('[data-kit-mini-detail-title]').textContent = miniButton.dataset.title;
      detail.querySelector('[data-kit-mini-detail-copy]').textContent = miniButton.dataset.description;
      return;
    }

    const kitItem = event.target.closest('[data-kit-item]');
    if (kitItem) {
      const list = kitItem.closest('[data-kit-contents-list], .cd-kit-contents__list');
      list?.querySelectorAll('[data-kit-item]').forEach((item) => {
        const active = item === kitItem;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (window.matchMedia('(max-width: 749px)').matches) {
        kitItem.closest('.cd-kit-contents__body')?.querySelector('.cd-kit-contents__visual')?.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'center'
        });
      }
      return;
    }

    const openUpsell = event.target.closest('[data-cd-upsell-dialog-open], button.cd-product-upsell__media');
    if (openUpsell) {
      const upsell = openUpsell.closest('[data-cd-product-upsell]');
      let dialog = upsell?.querySelector('[data-cd-upsell-dialog]');
      if (!dialog && upsell) {
        const sourceImage = openUpsell.querySelector('img');
        dialog = document.createElement('dialog');
        dialog.className = 'cd-product-upsell__dialog';
        dialog.dataset.cdUpsellDialog = '';
        dialog.innerHTML = '<div class="cd-product-upsell__dialog-header"><strong>Scrub Doctor Golf Towel</strong><button type="button" aria-label="Close enlarged towel image" data-cd-upsell-dialog-close>&times;</button></div>';
        if (sourceImage) {
          const enlargedImage = sourceImage.cloneNode(true);
          enlargedImage.removeAttribute('sizes');
          dialog.appendChild(enlargedImage);
        }
        upsell.appendChild(dialog);
      }
      if (dialog) dialog.showModal();
      return;
    }

    const closeUpsell = event.target.closest('[data-cd-upsell-dialog-close]');
    if (closeUpsell) {
      closeUpsell.closest('dialog')?.close();
      return;
    }

    const resultsLink = event.target.closest('.cd-result-proof');
    if (resultsLink) {
      const results = document.querySelector('#cd-product-results, .home-transformations');
      if (!results) return;
      event.preventDefault();
      results.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    const carouselButton = event.target.closest('[data-cd-carousel-previous], [data-cd-carousel-next]');
    if (carouselButton) {
      const controls = carouselButton.closest('[data-cd-carousel-controls]');
      const carousel = controls?.previousElementSibling;
      if (!carousel?.matches(SELECTOR.carousel)) return;
      const direction = carouselButton.hasAttribute('data-cd-carousel-next') ? 1 : -1;
      const cards = Array.from(carousel.querySelectorAll(SELECTOR.card));
      const current = Math.max(0, Math.min(cards.length - 1, Math.round(carousel.scrollLeft / carousel.clientWidth)));
      const next = (current + direction + cards.length) % cards.length;
      carousel.scrollTo({ left: cards[next].offsetLeft, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }
  });

  document.addEventListener('keydown', (event) => {
    const kitItem = event.target.closest('[data-kit-item]');
    if (kitItem && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      kitItem.click();
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-cd-upsell-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
